import {
  Dialog,
  IconButton,
  Button,
  styled,
  Typography,
  Box,
} from '@mui/material'
import { ClearIcon } from '@weblite/icons'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'
import { showCreateCourseDialog } from '../create-course/create-course-dialog.api'
import { HotSpot } from '$common/tour/components/hot-spot'

export function CreateCourseTourStartDialog({ isOpen }: { isOpen?: boolean }) {
  return (
    <Dialog
      open={!!isOpen}
      PaperProps={{
        sx: {
          maxWidth: '350px',
          backgroundColor: 'neutral100',
          borderRadius: '16px',
        },
      }}
    >
      <Container>
        <Header>
          <Typography variant="subtitle2" color="neutral900">
            {t('createCourseTourStartDialog.title')}
          </Typography>
          <IconButton onClick={closeCurrentModal}>
            <ClearIcon sx={{ color: 'neutral800' }} />
          </IconButton>
        </Header>

        <Typography variant="paragraph3" color="neutral800">
          {t('createCourseTourStartDialog.description')}
        </Typography>
        <ActionButtons>
          <Button
            variant="contained"
            color="neutral"
            onClick={closeCurrentModal}
          >
            {t('createCourseTourStartDialog.cancel')}
          </Button>
          <Box sx={{ position: 'relative' }}>
            <PrimaryButton
              fullWidth
              text={t('createCourseTourStartDialog.submit')}
              onClick={async () => {
                await closeCurrentModal()
                showCreateCourseDialog()
              }}
            />
            <HotSpot
              sx={{ position: 'absolute', top: '-4px', right: '-4px' }}
            />
          </Box>
        </ActionButtons>
      </Container>
    </Dialog>
  )
}

const Container = styled('div')`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Header = styled('div')`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`

const ActionButtons = styled('div')`
  gap: 12px;
  display: flex;
  align-items: center;
  & > button,
  & > div {
    width: calc(50% - 6px);
  }
`
